import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PeopleIcon from '@mui/icons-material/People';
import TimelineIcon from '@mui/icons-material/Timeline';
import Page from 'modules/Page';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project/ProjectsPage/constants';
import { toTitleCase } from 'utils';
import withNavigation from '../../withNavigation';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import ProjectDetailsPage from './ProjectDetailsPage';
import ProjectReportsPage from './ProjectReportsPage';
import ProjectStopesPage from './ProjectStopesPage';
import * as constants from './constants';
import { ProjectAreaPageParams } from './constants';
import useProjectAreaQueries, { ProjectAreaQueries } from './useProjectAreaQueries';

const page: Page<constants.ProjectAreaPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: context.functions.canViewTeam,
    teamId: params.entityId,
  }),
  component: withLicenceAndDisclaimer({
    projectIdIkey: 'entityId',
    Component: withNavigation({
      pageDataHook: useProjectAreaQueries,
      Component: makePage<ProjectAreaPageParams, [], ProjectAreaQueries>({
        titleFn: ([projectQuery]) => (projectQuery.data ? i18n._(toTitleCase(projectQuery.data.name)) : ''),
        parentPathTemplate: parentConstants.ROUTE_PATH,
        parentTitleFn: () => i18n._(parentConstants.TITLE),
      }),
      defaultRoute: constants.DETAILS_ROUTE_PATH,
      pageNavigation: [
        {
          title: i18n._(constants.DETAILS_TITLE),
          iconComponent: PeopleIcon,
          routeProps: {
            path: constants.DETAILS_ROUTE_PATH,
          },
          Component: ProjectDetailsPage,
        },
        {
          title: i18n._(constants.STOPES_TITLE),
          iconComponent: AccountTreeIcon,
          routeProps: {
            path: constants.STOPES_ROUTE_PATH,

          },
          Component: ProjectStopesPage,
        },
        {
          title: i18n._(constants.REPORTS_TITLE),
          iconComponent: TimelineIcon,
          routeProps: {
            path: constants.REPORTS_ROUTE_PATH,

          },
          Component: ProjectReportsPage,
        },
      ],
    }),
  }),
};

export default page;
